// SPDX-License-Identifier: Apache-2.0
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABIEncoder = exports.ABIPacked = void 0;
const ethers_1 = require("ethers");
class ABIPacked {
    constructor(bytes) {
        this.bytes = ethers_1.utils.arrayify(bytes);
    }
    keccak256() {
        return ethers_1.utils.arrayify(ethers_1.utils.keccak256(this.bytes));
    }
    toString() {
        return ethers_1.utils.hexlify(this.bytes);
    }
}
exports.ABIPacked = ABIPacked;
/** ABIEncoder encodes values into the Ethereum ABI.
    It supports values as either `[string, value]` pairs, or as `ABIValue`. A
    value either needs to be converted into the correct type for encoding, or
    fulfill the `ABIEncodable` interface. */
class ABIEncoder {
    constructor(...fields) {
        this.types = [];
        this.values = [];
        this.encode(...fields);
    }
    encode(...fields) {
        return this.encodeTagged(undefined, ...fields);
    }
    encodeTagged(contract, ...fields) {
        this.types = this.types.concat(fields.map((f) => {
            if (f.packTagged !== undefined)
                return "bytes";
            if (f instanceof Array)
                return f[0];
            else if (f instanceof String || typeof f === "string")
                return "string";
            else if (f instanceof Boolean || typeof f === "boolean")
                return "bool";
            else if (f.ABIType !== undefined)
                return f.ABIType();
            else if (f instanceof Uint8Array)
                return "bytes";
            throw new Error(`cannot encode ${typeof f}`);
        }));
        this.values = this.values.concat(fields.map((f) => {
            if (f.packTagged !== undefined)
                return f.packTagged(contract).bytes;
            if (f.asABI !== undefined)
                return f.asABI();
            if (f instanceof String || typeof f === "string")
                return f;
            if (f instanceof Boolean || typeof f === "boolean")
                return f;
            if (f instanceof Uint8Array)
                return f;
            if (f instanceof Array)
                if (f[1].asABI !== undefined)
                    return f[1].asABI();
                else
                    return f[1];
            throw new Error(`value not encodable ${f}`);
        }));
        return this;
    }
    pack_noprefix() {
        return new ABIPacked(ethers_1.utils.defaultAbiCoder.encode(this.types, this.values));
    }
    pack(tag, contract) {
        const enc = new ABIEncoder(tag, contract);
        return new ABIPacked(ethers_1.utils.defaultAbiCoder.encode(enc.types.concat(this.types), enc.values.concat(this.values)));
    }
}
exports.ABIEncoder = ABIEncoder;
//# sourceMappingURL=abiencoder.js.map